export default {
  data(){
    return {
      _debouncers_map: new Map()
    }
  },
  methods: {
    _handle_debounce(fn, args, delay = 200){
      const debouncer_idx = this._debouncers_map.get(fn)
      if (debouncer_idx) clearTimeout(debouncer_idx)
      this._debouncers_map.set(fn, setTimeout(async () => fn(...args), delay))
    },
    
    $debounce(fn, ...args) {
      this._handle_debounce(fn, args)
    },

    //example for another delay setting
    $debounce_175(fn, ...args) {
      this._handle_debounce(fn, args, 175)
    },

    $debounce_200(fn, ...args) {
      this._handle_debounce(fn, args, 200)
    },

    $debounce_350(fn, ...args) {
      this._handle_debounce(fn, args, 350)
    },

    $debounce_400(fn, ...args) {
      this._handle_debounce(fn, args, 400)
    },

    $debounce_500(fn, ...args) {
      this._handle_debounce(fn, args, 500)
    },

    $debounce_800(fn, ...args) {
      this._handle_debounce(fn, args, 800)
    },

    $debounce_1000(fn, ...args) {
      this._handle_debounce(fn, args, 1000)
    },

    $abortDebounce(fn) {
      const debouncer = this._debouncers_map.get(fn)
      if (debouncer) clearTimeout(debouncer)
    }
  },
  beforeUnmount(){
    this._debouncers_map.forEach((value, key, map) => {
      clearTimeout(value)
      map.delete(key)
    })
  }
}